import { Outlet, createRootRoute, useNavigate } from '@tanstack/react-router';
import { useOnDisconnect } from '@puzzlehq/sdk';
import { Route as IndexRoute } from './index.js';
import 'ui_2/src/index.css';
import { GameCompleteDialog } from '@src/components/GameCompleteDialog.js';

export const Route = createRootRoute({
  component: function Component() {
    const navigate = useNavigate();

    useOnDisconnect(() => {
      navigate({ to: IndexRoute.to });
    }, []);

    return (
      <div className='h-[100dvh]'>
        <Outlet />
        <GameCompleteDialog />
      </div>
    );
  },
});
